// extracted by mini-css-extract-plugin
module.exports = {"label":"ImageCheckbox_label__2ueYM","img":"ImageCheckbox_img__2RrVg","input":"ImageCheckbox_input__159zH","text":"ImageCheckbox_text__1E5Si"};